import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { TranslocoDirective } from "@jsverse/transloco";
import { BulkUploadContextService } from "@m19-board/services/bulk-upload/bulk-upload-context.service";
import { SpinnerComponent } from "@front/m19-ui";
import { BulkUploadFileComponent } from "../bulk-upload-file/bulk-upload-file.component";
import { BulkUploadPreviewComponent } from "../bulk-upload-preview/bulk-upload-preview.component";
import { BulkUploadRunProgressComponent } from "../bulk-upload-run/bulk-upload-run-progress.component";
import { BulkUploadRunComponent } from "../bulk-upload-run/bulk-upload-run.component";
import { BulkUploadStepperComponent } from "../bulk-upload-stepper/bulk-upload-stepper.component";

@Component({
  selector: "app-bulk-upload-layout",
  imports: [
    TranslocoDirective,
    BulkUploadFileComponent,
    BulkUploadPreviewComponent,
    SpinnerComponent,
    BulkUploadRunComponent,
    BulkUploadRunProgressComponent,
    BulkUploadStepperComponent,
  ],
  templateUrl: "./bulk-upload-layout.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadLayoutComponent {
  private readonly bulkUploadContextService = inject(BulkUploadContextService);

  public readonly bulkFlowState = toSignal(this.bulkUploadContextService.bulkFlowState$, { requireSync: true });
  public readonly fileMetadata = toSignal(this.bulkUploadContextService.fileMetadata$);
  public readonly previewBuckets = toSignal(this.bulkUploadContextService.previewBuckets$);
  public readonly runResult = toSignal(this.bulkUploadContextService.runResult$);
  public readonly progress = toSignal(this.bulkUploadContextService.progress$, {
    equal: (_, __) => false,
  });

  public readonly step = computed(() => this.bulkFlowState().step);

  public readonly previewColumnDefs = this.bulkUploadContextService.getPreviewGridColumnsDefs();
  public readonly runResultColumnDefs = this.bulkUploadContextService.getRunResultGridColumnsDefs();

  upload(file: File) {
    this.bulkUploadContextService.upload(file);
  }

  uploadPlainText(content: string) {
    this.bulkUploadContextService.uploadPlainText(content);
    this.preview();
  }

  preview() {
    this.bulkUploadContextService.preview().subscribe();
  }
  run() {
    this.bulkUploadContextService.run().subscribe();
  }

  backToUpload() {
    this.bulkUploadContextService.backToUpload();
  }

  removeFile() {
    this.bulkUploadContextService.removeFile();
  }

  export() {
    this.bulkUploadContextService.export();
  }

  closeImport() {
    this.bulkUploadContextService.resetImport();
  }
}
